export const SET_DATA = 'SET_DATA';
export const CHANGE_OPTION_DATA = 'CHANGE_OPTION_DATA';
export const RESET_OPTION_DATA = 'RESET_OPTION_DATA';
export const CHANGE_SUB_OPTION_DATA = 'CHANGE_SUB_OPTION_DATA';
export const RESET_SUB_OPTION_DATA = 'RESET_SUB_OPTION_DATA';
export const CHANGE_OPTION_INPUT_DATA = 'CHANGE_OPTION_INPUT_DATA';
export const CHANGE_OPTION_QUANTITY_DATA = 'CHANGE_OPTION_QUANTITY_DATA';
export const SET_DELIVERY_DATA = 'SET_DELIVERY_DATA';
export const SET_SELECT_CHECKBOX = 'SET_SELECT_CHECKBOX';
export const SET_REFERENCE_FILE = 'SET_REFERENCE_FILE';
export const SET_REFERENCE_CONTENTS = 'SET_REFERENCE_CONTENTS';
export const SET_PRICE = "SET_PRICE";
export const SET_SEARCH_STEP = "SET_SEARCH_STEP";
export const SET_MIN_AND_MAX_PRICE = "SET_MIN_AND_MAX_PRICE";
export const WORK_TYPE_ORDER = "주문";
export const WORK_TYPE_BOOKN = "예약";
